import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { IS_BROWSER } from '@libs/is-browser';
import { Store } from '@ngxs/store';
import { environment } from '@apps/clos-sessions/environments';
import { RevenueCatClient } from '@apps/clos-sessions/services/revenue-cat-client';
import { AuthState } from '@apps/clos-sessions/state/auth';
import { FetchCustomerInfo } from '@apps/clos-sessions/state/subscriptions';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsStateInitGuard implements CanActivate {
  protected isBrowser = inject(IS_BROWSER);

  protected store = inject(Store);

  protected revenueCat = inject(RevenueCatClient);

  canActivate(): boolean {
    if (this.isBrowser) {
      this.initPurchaseFeature();
    }

    return true;
  }

  protected async initPurchaseFeature(): Promise<void> {
    const user = this.store.selectSnapshot(AuthState.user);

    if (!user) {
      return;
    }

    await this.revenueCat.initialize({
      apiKey: environment.revenuecat.apiKey,
      appUserId: user.id,
      attrs: {
        CLOS_id: user.id,
      },
    });

    this.store.dispatch(new FetchCustomerInfo());
  }
}
